import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {BrowserModule} from '@angular/platform-browser';
import {Routes, RouterModule} from '@angular/router';

import {LandingComponent} from './examples/landing/landing.component';
import {CookiesPolicyComponent} from './components/cookies-policy/cookies-policy.component';
import {PolicyComponent} from './examples/policy/policy.component'

const routes: Routes = [
    {path: '', redirectTo: 'home', pathMatch: 'full'},
    {path: 'home', component: LandingComponent},
    {path: 'cookies-policy', component: CookiesPolicyComponent},
    {path: 'privacy-policy', component: PolicyComponent},
    {path: '**', redirectTo: 'home'},
];

@NgModule({
    imports: [
        CommonModule,
        BrowserModule,
        RouterModule.forRoot(routes, { useHash: true, relativeLinkResolution: 'legacy' })
    ],
    exports: [],
})
export class AppRoutingModule {
}
